'use client';

import { useEffect } from 'react';
import { ErrorScreen } from '@/components/ui/ErrorScreen';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Runtime Error:', error);
  }, [error]);

  return (
    <ErrorScreen
      code="500"
      label="SYSTEM_FAILURE"
      title="A critical error occurred."
      message={error.message || "Something went wrong in the component tree. Our agents are investigating the breach."}
      terminal="service-manager restart --force all"
      showRetry={true}
    />
  );
}
